import { ACTION } from "../../../util/utils";
import { KEYS, MODULE_KEY,
  SPECIAL_ORDER_VENDOR_RECEIPT_FETCH,
  SPECIAL_ORDER_VENDOR_RECEIPT_SUCCESS,
  SPECIAL_ORDER_VENDOR_RECEIPT_FAIL } from "./actions";

export const REDUCER_KEY = KEYS[MODULE_KEY + ACTION.STATE_KEY]

export interface ISpecialOrderQueueState {
  data: any[];
  loading: boolean;
  error: any;
  // new pieces of state for vendor receipt call
  vendorReceiptLoading?: boolean;
  vendorReceiptError?: any;
}

const defaultState: ISpecialOrderQueueState = {
  data: [],
  loading: false,
  error: null,
  vendorReceiptLoading: false,
  vendorReceiptError: null,
};

export const specialOrderQueueReducer = (
  state = defaultState,
  { type, payload }: any
) => {
  switch (type) {
    case KEYS[MODULE_KEY + ACTION.FETCH]:
      return {
        ...state,
        loading: true,
      };
    case KEYS[MODULE_KEY + ACTION.SUCCESS]:
      return {
        ...state,
        loading: false,
        data: Array.isArray(payload) ? [...payload] : [payload],
      };
    case KEYS[MODULE_KEY + ACTION.FAIL]:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    // vendor receipt lifecycle (use explicit action constants)
    case SPECIAL_ORDER_VENDOR_RECEIPT_FETCH:
      return {
        ...state,
        vendorReceiptLoading: true,
        vendorReceiptError: null,
      };
    case SPECIAL_ORDER_VENDOR_RECEIPT_SUCCESS:
      return {
        ...state,
        vendorReceiptLoading: false,
      };
    case SPECIAL_ORDER_VENDOR_RECEIPT_FAIL:
      return {
        ...state,
        vendorReceiptLoading: false,
        vendorReceiptError: payload,
      };

    default:
      return state;
  }
};
